/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMessageCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M12.773 3.5A7.75 7.75 0 005.8 14.635c.112.232.134.503.05.757l-1.39 4.172 4.171-1.39c.254-.085.525-.063.757.05A7.75 7.75 0 1012.773 3.5zm-9.25 7.75a9.25 9.25 0 115.393 8.41l-4.931 1.643a1 1 0 01-1.265-1.265l1.644-4.93a9.218 9.218 0 01-.84-3.858z'
      />
    </svg>
  );
}

export default SvgMessageCircle;
